import { Team } from "../../types";

export const lckTeams: Team[] = [
  {
    name: "GEN",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1655210113163_GenG_logo_200407-05.png",
    seed: 1,
  },
  {
    name: "T1",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819523085_t1-2021-worlds.png",
    seed: 2,
  },
  {
    name: "LSB",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2Fliiv-sandbox-new.png",
    seed: 3,
  },
  {
    name: "DK",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819456274_dwg-kia-2021-worlds.png",
    seed: 4,
  },
  {
    name: "KT",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2Fkt_darkbackground.png",
    seed: 5,
  },
  {
    name: "DRX",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592589284897_DRXDRX-01-FullonDark.png",
    seed: 6,
  },
  {
    name: "KDF",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1641186009897_KDF_KR_logo.png",
    seed: 7,
  },
  {
    name: "NS",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FNSFullonDark.png",
    seed: 8,
  },
  {
    name: "BRO",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FBRO_color_darkbackground.png",
    seed: 9,
  },
  {
    name: "HLE",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819564399_hle-2021-worlds.png",
    seed: 10,
  },
];
